// extracted by mini-css-extract-plugin
module.exports = {"container":"_3nwJkqAQZM93_QLqpPHVDc","groupsList":"RMNf9lsPRH3WmT0_O4_TR"};